import IntlMessages from 'helpers/IntlMessages'

export const LOG_SWITCH_TO_DEFAULT_FILTER = {
  fromUser: '',
  toUser: '',
  reason: '',
  startDate: '',
  endDate: '',
  sortBy: 'createdAt:DESC'
}

export const LOG_SWITCH_TO_MAPPING_FILTER = Object.freeze({
  fromUser: <IntlMessages id="log_switch_to.from_user" />,
  toUser: <IntlMessages id="log_switch_to.to_user" />,
  reason: <IntlMessages id="log_switch_to.reason" />,
  startDate: <IntlMessages id="log_switch_to.period" />,
  endDate: <IntlMessages id="log_switch_to.period" />
})
